import { useSelector } from "react-redux";

import { Box, Grid, Typography } from "@mui/material";

const PeopleData = ({ subheaderStyle, useMobileLayout }) => {
  const selectedRow = useSelector((state) => state.dataExplorer.selectedRow);
  return (
    <Grid
      item
      xs={12}
      md={useMobileLayout ? 12 : 8}
      sx={{ flexGrow: 1, overflowY: "auto" }}
    >
      <Box>
        {selectedRow.row.email && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Email
              <Typography
                sx={{
                  color: "primary.contrastText",
                }}
              >
                {selectedRow.row.email}
              </Typography>
            </Typography>
          </Box>
        )}
        {selectedRow.row.phone && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Phone
              <Typography
                sx={{
                  color: "primary.contrastText",
                }}
              >
                {selectedRow.row.phone}
              </Typography>
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default PeopleData;
